import { RootState } from 'types/state';

export const getSaveState = (state: RootState) => state.save;
